import { MetadataTableName } from '@bechtel/sr-types';
import { TableMetadataContext } from '~/components';
import Cables from './cables';
import Equipments from './equipment';
import Jumpers from './jumpers';
import Raceways from './raceways';
import Terminations from './terminations';

export const navbarItems = [
  {
    title: 'Cables',
    path: 'cable',
    parentPath: 'jobsite-feedback',
    default: true,
  },
  {
    title: 'Raceways',
    path: 'raceway',
    parentPath: 'jobsite-feedback',
    default: true,
  },
  {
    title: 'Equipment',
    path: 'equipment',
    parentPath: 'jobsite-feedback',
    default: true,
  },
  {
    title: 'Jumpers',
    path: 'jumper',
    parentPath: 'jobsite-feedback',
    default: true,
  },
  {
    title: 'Terminations',
    path: 'termination',
    parentPath: 'jobsite-feedback',
    default: true,
  },
];

export const jobsiteFeedbackComponents = {
  cable: (
    <TableMetadataContext metadataTableName={MetadataTableName.CABLE}>
      <Cables />
    </TableMetadataContext>
  ),
  jumper: (
    <TableMetadataContext metadataTableName={MetadataTableName.JUMPER}>
      <Jumpers />
    </TableMetadataContext>
  ),
  raceway: (
    <TableMetadataContext metadataTableName={MetadataTableName.RACEWAY}>
      <Raceways />
    </TableMetadataContext>
  ),
  equipment: (
    <TableMetadataContext metadataTableName={MetadataTableName.EQUIPMENT}>
      <Equipments />
    </TableMetadataContext>
  ),
  termination: (
    <TableMetadataContext metadataTableName={MetadataTableName.CABLE}>
      <Terminations />
    </TableMetadataContext>
  ),
};
